// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pangoro: PokeData = {
  "id": 675,
  "name": "pangoro",
  "height": 21,
  "weight": 1360,
  "base_experience": 173,
  "types": [
    PokeType.FIGHTING,
    PokeType.DARK
  ],
  "api_moves": [
    "karate-chop",
    "comet-punch",
    "tackle",
    "body-slam",
    "leer",
    "slash",
    "vital-throw",
    "crunch",
    "taunt",
    "arm-thrust",
    "sky-uppercut",
    "hammer-arm",
    "night-slash",
    "bullet-punch",
    "low-sweep",
    "entrainment",
    "circle-throw",
    "work-up",
    "parting-shot"
  ],
  "moves": [
    "karate-chop",
    "tackle",
    "body-slam",
    "leer",
    "crunch",
    "night-slash",
    "vacuum-wave",
    "meteor-assault",
    "night-daze",
    "flatter",
    "phantom-force",
    "close-combat",
    "seismic-toss"
  ],
  "evolution_chain": {
    "id": 346,
    "item": null,
    "species": [
      {
        "name": "pancham",
        "order": 675,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pangoro",
        "order": 676,
        "types": [
          PokeType.FIGHTING,
          PokeType.DARK
        ],
        "evolves_from_species_id": 674,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 127,
    "speed": 87,
    "ability_power": 186
  },
  "stat_changes": [],
  "catch_rate": 65,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
